import { InputSkeleton } from '@/_components';
import { CardContainer, FormLayout, SectionHeadingSkeleton } from '@/_containers';
import AddressFormLoading from '@/_containers/inputs/address/loading';

export default function Loading() {
  return (
    <>
      <CardContainer>
        <SectionHeadingSkeleton />

        <FormLayout>
          <InputSkeleton className="col-span-12 sm:col-span-6" />
          <InputSkeleton className="col-span-12 sm:col-span-6" />
        </FormLayout>
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />

        <AddressFormLoading />
      </CardContainer>

      <CardContainer>
        <SectionHeadingSkeleton />

        <AddressFormLoading />
      </CardContainer>
    </>
  );
}
